import * as React from 'react';
import { ISearchSuggestionItem } from 'PyzShopUi/scripts/search-suggestion/interfaces';
import { etrackerCCAttributes } from 'PyzShopUi/scripts/etracker/EtrackerCCAttributes';

interface IQueryListProps {
    suggestions: ISearchSuggestionItem[];
    searchValue: string;
}

const QueryList: React.FunctionComponent<IQueryListProps> = props => {
    const { suggestions, searchValue } = props;
    const dataTrackAttr = {
        "data-track-id": 'suggestSearchTerm'
    };

    const prepareUrl = (url: string, itemName: string): string => {
        const searchUrl = new URL(url, window.location.origin);
        etrackerCCAttributes.prepareClickCCAttributes(searchUrl, itemName);

        return searchUrl.toString();
    }

    const highlightMatch = React.useCallback((suggestion: string, searchValue: string) => {
        const lowerCaseSuggestion: string = suggestion.toLowerCase();
        const lowerCaseTerm: string = searchValue.toLowerCase();
        const startIndex: number = lowerCaseSuggestion.indexOf(lowerCaseTerm);

        if (startIndex === -1 || searchValue.length === 0) {
            return <span>{suggestion}</span>;
        }

        const preMatch: string = suggestion.substring(0, startIndex);
        const match: string = suggestion.substring(startIndex, startIndex + searchValue.length);
        const postMatch: string = suggestion.substring(startIndex + searchValue.length);

        return (
            <span {...dataTrackAttr}>
                <b>{preMatch}</b>
                {match}
                <b>{postMatch}</b>
            </span>
        );
    }, []);

    const displaySuggests = suggestions.map((suggestion: ISearchSuggestionItem, index: number) => (
        <li key={index} className='search-suggestions-item'>
            <a href={prepareUrl(suggestion.url, suggestion.name)} title={suggestion.name}>
                <i className='icon icon-size-small icon-search'/>  {highlightMatch(suggestion.name, searchValue)}
            </a>
        </li>
    ));

    return (
        <ul>
            {displaySuggests}
        </ul>
    );
};

export default QueryList;
